import { IComponentOptions } from 'angular';
import { RegentsPrepWizardTransferCtrl } from './regents-prep-wizard-transfer.controller';

export const RegentsPrepWizardTransferComponent: IComponentOptions = {
  bindings: {
    initialWizardState: '<',
    studentSupports: '<',
    schoolSupports: '<',
    currentSchool: '<',
    currentUser: '<',
  },
  controller: RegentsPrepWizardTransferCtrl,
  template: require('./regents-prep-wizard-transfer.html'),
};
